import {IStationApi} from '../api/station-api.service';
import {IImomoErrorService} from '../error/error.service';

export function uniqueStationCodeFactory(stationApi:IStationApi,
                                         $q:ng.IQService,
                                         $mdDialog:ng.material.IDialogService,
                                         $translate:ng.translate.ITranslateService,
                                         imomoErrorService: IImomoErrorService) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope:ng.IScope, el:ng.IAugmentedJQuery,
                    attrs:ng.IAttributes, ngModel:any) {
      ngModel.$asyncValidators.unique = (stationCode:string) => {
        const initialCode:string = attrs['initialStationCode'];
        const deferred = $q.defer<void>();
        if (stationCode == initialCode) {
          deferred.resolve();
        } else {
          stationApi.isMeteoStationCodeUnique(stationCode)
            .then((httpData: {available: boolean, message: string}) => {
              if(httpData.available) {
                stationApi.isDischargeStationCodeUnique(stationCode, false)
                  .then((httpData: {available: boolean, message: string}) => {
                    if(!httpData.available) {
                      const dialog = $mdDialog.alert()
                          .title($translate.instant(
                              'STATION_PAIR_NOTIFICATION', {stationCode: stationCode, stationType:'Discharge'}))
                          .textContent($translate.instant(
                              'STATION_PAIR_NOTIFICATION_EXTENDED', {stationCode: stationCode, stationType:'Discharge'}))
                          .ok($translate.instant(
                              'OK'))
                      $mdDialog.show(dialog)
                    } 
                    deferred.resolve();
                  })
                deferred.resolve();
              } else {
                imomoErrorService.showErrorDetailsDialog(httpData.message);
                deferred.reject();
              }
            }).catch(errData => {
              deferred.reject()
            });
        }
        return deferred.promise;
      }
    }
  }
}

uniqueStationCodeFactory.$inject = ['stationApi', '$q', '$mdDialog', '$translate', 'imomoErrorService'];



/** WEBPACK FOOTER **
 ** ./app/meteostation/unique-station-code.directive.ts
 **/